import React,{useId} from 'react';

const MASTER='/brand/celebrations-cairn-v2/toto-master-480.webp';
const MOTION='/brand/celebrations-cairn-motion-v1/';
// The body is always the approved master. Generated frames supply only these
// small regions, so a blink/wag cannot redraw his face, coat, proportions or paws.
const DETAILS='M0 75 H205 V305 L238 347 L222 386 L160 405 L90 394 L0 345 Z M430 0 H655 V250 H430 Z M690 0 H835 V221 H690 Z';

export default function TotoCelebrationMotion({onLoad}) {
 const id=`toto-motion-${useId().replace(/:/g,'')}`;
 const sources=[MASTER,`${MOTION}alert-480.webp`,`${MOTION}blink-480.webp`];
 const shapes=fill=><><path d={DETAILS} fill={fill}/><ellipse cx="710" cy="282" rx="64" ry="42" fill={fill}/><ellipse cx="805" cy="247" rx="31" ry="42" fill={fill}/></>;
 return <>
  <svg className="today-celebration-art__illustration" viewBox="0 0 901 955" preserveAspectRatio="xMinYMax meet" aria-hidden="true" focusable="false">
   <defs>
    <mask id={`${id}-body`} maskUnits="userSpaceOnUse" x="0" y="0" width="901" height="955" style={{maskType:'luminance'}}><rect width="901" height="955" fill="white"/>{shapes('black')}</mask>
    <mask id={`${id}-details`} maskUnits="userSpaceOnUse" x="0" y="0" width="901" height="955" style={{maskType:'luminance'}}><rect width="901" height="955" fill="black"/>{shapes('white')}</mask>
   </defs>
   <image className="today-celebration-art__body" href={MASTER} width="901" height="955" preserveAspectRatio="none" mask={`url(#${id}-body)`}/>
   <g mask={`url(#${id}-details)`}>
    {sources.map((src,index)=><image key={src} href={src} width="901" height="955" preserveAspectRatio="none" className={`today-celebration-art__motion-frame is-${['rest','alert','blink'][index]}`}/>)}
   </g>
  </svg>
  {sources.map(src=><img key={src} hidden className="today-celebration-art__preload" src={src} onLoad={onLoad} alt="" draggable="false"/>)}
 </>;
}
